import React, { lazy, Suspense, useState } from "react";
import { useBotbPassDrawerContext } from "./botb-pass-modal-context";
import CloseModalIcon from "../../../../shared-components/icons/CloseModalIcon";
import { ErrorBoundary } from "react-error-boundary";
const SinglePurchase = lazy(() => import("./SinglePurchase"));
const SubscriptionPackages = lazy(() => import("./SubscriptionPackages"));
const PostalEntry = lazy(() => import("./PostalEntry"));

const TABS_DATA = [
  {
    title: "Postal",
    htmlTitle: "POSTAL",
  },
  {
    title: "Single Purchase",
    htmlTitle: "SINGLE PURCHASE",
  },
  {
    title: "Subscription",
    htmlTitle: "SUBSCRIPTION",
  },
] as const;

export const BotbPassDrawerContent = () => {
  const { closeModal, place } = useBotbPassDrawerContext();
  const [activeTab, setActiveTab] = useState<"Postal" | "Single Purchase" | "Subscription">("Subscription");

  return (
    <>
      <div data-name="Overlay" className="fixed-theme inset-0 z-[9999] bg-black/80"></div>
      <div
        data-name="PopupContainer"
        className={"fixed inset-0 z-[99999] w-full min-h-full overflow-x-hidden overflow-y-auto font-jost"}>
        <div className={"flex flex-col items-center justify-center m-auto w-full min-h-full lg:p-6"}>
          <div
            className={
              "relative flex flex-col w-full max-lg:grow lg:max-w-[1144px] lg:min-h-[755px] bg-gray-4 lg:rounded-2xl"
            }>
            <button
              onClick={closeModal}
              aria-label="Close"
              className={"absolute flex items-center justify-center top-3 right-3 lg:top-2 lg:right-2 lg:size-10"}>
              <CloseModalIcon className={"size-6 text-gray-5"} />
            </button>

            <div className={"overflow-hidden lg:rounded-2xl"}>
              <div className={"flex flex-col gap-8 pt-12 px-4 bg-white lg:gap-8 lg:pt-8 lg:rounded-t-2xl"}>
                <div
                  className={
                    "self-stretch text-dark-1 text-center text-[22px] font-bold leading-7 lg:mx-auto lg:max-w-[560px] lg:text-2xl lg:leading-7.5"
                  }>
                  £2.3M in prizes every month, across 6 luxury cars + 15 more competitions
                </div>

                <div className="flex flex-col items-center gap-3 w-full">
                  <div className="flex flex-col items-center gap-6 max-lg:w-full lg:flex-row lg:justify-center lg:gap-12 lg:border-b lg:border-solid lg:border-black/8">
                    <div className="text-primary text-center font-jost text-lg font-bold leading-6 lg:text-lg lg:font-semibold lg:leading-6 lg:whitespace-nowrap">
                      How would you like to enter?
                    </div>

                    <div className="flex items-center justify-between w-full border-b border-solid border-black/8 lg:justify-center lg:w-auto lg:gap-6 lg:border-0">
                      {TABS_DATA.map((tab, index) => (
                        <button
                          key={`tab_${index}`}
                          type="button"
                          className={`relative flex items-center justify-center shrink-0 h-[50px] m-0 p-0 bg-transparent border-0 border-b-[3px] border-solid cursor-pointer lg:h-[54px] lg:px-2 lg:border-b-2 ${
                            tab.title === activeTab ? "border-primary" : "border-transparent"
                          } ${tab.title === "Postal" ? "" : tab.title === "Single Purchase" ? "w-[126px] lg:w-auto" : "w-[107px] lg:w-auto"}`}
                          onClick={() => setActiveTab(tab.title)}>
                          {tab.title === "Subscription" && (
                            <span
                              className={
                                "absolute -top-[5px] left-1/2 -translate-x-1/2 inline-flex items-center justify-center px-2 py-[3px] bg-red-1 rounded-full border border-solid border-red-2 lg:-top-[13px]"
                              }>
                              <span className="text-white text-center font-jost text-[9px] font-semibold leading-[10px] whitespace-nowrap lg:text-xs lg:leading-4">
                                Save up to 75%*
                              </span>
                            </span>
                          )}
                          <span
                            className={`text-[13px] font-medium leading-4.5 uppercase tracking-[0] lg:text-base lg:leading-5.5 ${
                              tab.title === activeTab ? "text-dark-1" : "text-gray-1"
                            } ${tab.title === "Postal" ? "w-[50px] text-center lg:w-auto" : "text-center"}`}>
                            {tab.htmlTitle}
                          </span>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <ErrorBoundary fallback={<span>Something went wrong.</span>}>
                <Suspense fallback={<div className={"min-h-[490px]"} />}>
                  {activeTab === "Postal" ? <PostalEntry /> : null}
                  {activeTab === "Single Purchase" ? <SinglePurchase /> : null}
                  {activeTab === "Subscription" ? <SubscriptionPackages place={place} /> : null}
                </Suspense>
              </ErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
